<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Menu Item Extras</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                        <button type="button" class="btn btn-primary" data-toggle="modal" data-original-title="test"
                            data-target="#exampleModal" (click)="open()">Add Menu Item Extra</button>                      
                    </div>
                    <app-menu-item-extra-list></app-menu-item-extra-list>
                </div>
            </div>
        </div>
    </div>
</div>
<app-menu-extra-modal #menuExtraModal [addOrEdit]="'Add'" [menuItemExtraId]="selectedId"></app-menu-extra-modal>
<!-- Container-fluid Ends-->